const recordingTranslation = {
  mode: 'ko',
  searchType: '검색 방식',
  generalSearch: '일반',
  patientIdSearch: 'patientId',
  patientIdSearchPlaceholder: 'patientId 전체 값 입력',
  menu: '초음파',
  recordingMenu: '영상 리스트',
  captureMenu: '캡쳐 리스트',
  migrationMenu: '영상 이전',
  mothersMenu: '마더스 다이어리',
  humancityMenu: '휴먼시티',

  recordingListTitle: '초음파 영상 리스트',
  captureListTitle: '초음파 캡쳐 리스트',
  mothersListTitle: '마더스 리스트',
  humancityListTitle: '휴먼시티 리스트',
  searchRecording: '초음파 영상 검색',
  searchCapture: '초음파 캡쳐 검색',
  searchAppUser: '유저 검색',
  searchMothers: '마더스 리스트 검색',
  searchHumancity: '휴먼시티 리스트 검색',
  selectMommytalk: '마미톡 사용자 검색',
  selectMommytalkHospital: '마미톡 사용자 병원 선택',
  selectMommytalkUser: '마미톡 사용자 이름 선택',
  userDetailInfo: '사용자의 상세 정보',
  howToSearch: '검색 도움말',
  help: '도움말',
  transfer: '마미톡으로 이전',
  transferFailed: '이전 실패',
  transferFailedMessage: '마더스 다이어리 영상 이전에 실패했습니다.',
  transferFailedVideoSeqs: '실패 영상',
  transferFailedMoreCount: '외 {{count}}건',
  transferFailedDetails: '상세 오류 보기',
  migrationRestoreRequestedMessage:
    '원본 파일 복원 요청을 시작했습니다. 복원 완료 후 다시 시도해 주세요.',
  migrationRestoringMessage: '원본 파일 복원이 진행 중입니다. 복원 완료 후 다시 시도해 주세요.',
  migrationSourceMissingMessage: '마더스 원본 파일을 찾을 수 없습니다.',
  migrationAvailability: '이전 가능 여부',
  migrationReady: '즉시 이전 가능',
  migrationRestoreRequired: '복원 필요',
  migrationRestoring: '복원 중',
  migrationSourceNotFound: '원본 없음',
  migrationStatusUnknown: '확인 실패',

  seq: '번호',
  thumbnail: '썸네일',
  capture: '캡쳐',
  captureImage: '캡쳐 이미지',
  patientId: 'patientId',
  barcode: '바코드',
  videoLength: '비디오 길이',
  hospital: '병원',
  device: '마미박스',
  recordedAt: '촬영일시',
  registeredAt: '등록일시',
  public: '공개',
  private: '비공개',

  chartNumber: '차트 번호',
  name: '이름',
  babyName: '아기 이름',
  id: '아이디',
  nickName: '닉네임',
  recordingCount: '영상 개수',
  signUpDate: '가입일',
  dateOfBirth: '출산 예정일',
  treatedHospital: '진료 받은 병원명',
  phoneNumber: '전화번호',
  email: '이메일',
  status: '회원상태',
  leave: '탈퇴함',
  normal: '정상',
  hospitalName: '병원명',
  fileName: '파일명',
  fileSize: '파일 크기',
  select: '선택',
  mothersName: '마더스 사용자 이름',
  mothersPhone: '마더스 사용자 전화번호',
  mothersId: '마더스 사용자 아이디',
  humancityName: '휴먼시티 사용자 이름',
  humancityPhone: '휴먼시티 사용자 전화번호',
  humancityId: '휴먼시티 사용자 아이디',
  mommytalkName: '마미톡 사용자 이름',
  mommytalkPhone: '마미톡 사용자 전화번호',
  mommytalkBarcode: '마미톡 사용자 아기 바코드',
  mommytalkHospital: '마미톡 사용자 병원 이름',

  thumbnailMessage: '클릭 시 새 창에서 영상 재생',
  howToSearchMessage1: '1. 바코드 전체(11자리)를 입력하여 검색',
  howToSearchMessage2: '2. 디바이스 이름을 입력하여 검색 (ex: MB2-B00057)',
  howToSearchMessage3: '3. 병원을 선택한 후에 병실명을 일부 입력하여 검색',
  howToSearchMessage4: '4. patientId 검색을 선택하고 전체 값을 입력하여 검색',
  noBarcodeMessage: '바코드가 없는 사용자 입니다.',

  net30Flag: 'Net30',

  // 복원 이력
  restoreHistory: '복원 이력',
  restoreHistoryNone: '이력 없음',
  restoreRequested: '요청됨',
  restoreRestoring: '복원 중',
  restoreRestored: '복원 완료',
  restoreReArchived: '재보관',
  restoreExpired: '만료됨',
  restoreFailed: '실패',
  restoreRequestedAt: '요청',
  restoreCompletedAt: '복원 완료',
  restoreExpiresAt: '만료',
  restoreTierStandard: '표준',
  restoreTierExpedited: '긴급',
  restoreTierBulk: '대량',
  restoreMoreButton: '더보기',
  restoreCollapseButton: '접기',
  restoreTotalCount: '총 {{count}}건 중 최근 10개 표시',
};

export default recordingTranslation;
